export const locales = {
  fr: {
    title: "Qui se présente aux élections communales?",
    update: "Mise à jour",
    filter: "Filtrer par parti politique",
    communePlaceholder: "Entrez le nom d'une commune",
    all: "Tous les partis",
    seeAll: "VOIR TOUT",
    closeAll: "TOUT FERMER",
    or: "ou",
    noDataList: "Aucune liste n'a encore été publiée",
    noDataSmall: "Les noms des candidats ne sont pas encore connus",
    firstMandate: "Première candidature",
    age: "Âge",
    occupation: "Profession",
    noCommune: "Pas de résultats trouvés pour",
    communeTypeList: "Représentation proportionnelle",
    communeTypeSmall: "Majorité relative",
    noDataAvailable: "Non communiqué",
    footerTitle: "Recherchez les candidats dans d'autres communes",
    lastUpdateDate: "24.01.2023",
    candidates: "Candidats",
  },
  de: {
    title: "Wer kandidiert bei den Gemeindewahlen?",
    update: "Letztes Update",
    filter: "Nach Partei filtern",
    communePlaceholder: "Geben Sie einen Gemeindenamen ein",
    all: "Alle Parteien",
    seeAll: "ALLE KANDIDATEN",
    closeAll: "ALLE SCHLIESSEN",
    or: "oder",
    noDataList: "Es wurde noch keine Liste veröffentlicht",
    noDataSmall: "Es gibt noch keine Informationen über die Kandidaten",
    firstMandate: "Erste Kandidatur",
    age: "Alter",
    occupation: "Beruf",
    noCommune: "Keine Ergebnisse gefunden für",
    communeTypeList: "Proporzgemeinde",
    communeTypeSmall: "Majorzgemeinde",
    noDataAvailable: "Nicht mitgeteilt",
    footerTitle:
      "Hier finden Sie andere Gemeinden, die Sie interessieren könnten",
    lastUpdateDate: "24.01.2023",
    candidates: "Kandidaten",
  },
  en: {
    title: "Who is running for the municipal elections?",
    update: "Last update",
    filter: "Filter by party",
    communePlaceholder: "Enter a commune name",
    all: "All parties",
    seeAll: "SEE ALL",
    closeAll: "CLOSE ALL",
    or: "or",
    noDataList: "No list has yet been published",
    noDataSmall: "No list has yet been published",
    firstMandate: "First candidacy",
    age: "Age",
    occupation: "Occupation",
    noCommune: "No results found for",
    communeTypeList: "List ballot",
    communeTypeSmall: "List small ballot",
    noDataAvailable: "N/A",
    footerTitle: "Search for candidates in other municipalities",
    lastUpdateDate: "24.01.2023",
    candidates: "Candidates",
  },
  pt: {
    title: "Quem se candidata às eleições comunais?",
    update: "Última atualização",
    filter: "Filtrar por partido",
    communePlaceholder: "Digite o nome de uma comunidade",
    all: "Todos os partidos",
    seeAll: "VER TUDO",
    closeAll: "FECHAR TUDO",
    or: "ou",
    noDataList: "Nenhuma lista foi publicada ainda",
    noDataSmall: "Não há dados para esta comunidade ainda",
    firstMandate: "Primeira candidatura",
    age: "Idade",
    occupation: "Profissão",
    noCommune: "Nenhum resultado encontrado para",
    communeTypeList: "Proporzgemeng",
    communeTypeSmall: "Majorzgemeng",
    noDataAvailable: "Não disponível",
    footerTitle:
      "Procure por candidatos em outras comunidades que possam interessar-lhe",
    lastUpdateDate: "24.01.2023",
    candidates: "Candidatos",
  },
};
